import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';
import {
  BsTelephoneFill,
  BsWhatsapp,
  BsEnvelopeFill,
  BsGeoAltFill,
} from "react-icons/bs";

function Mumbaitokhandalataxifare() {



const cardData = {
  keyword: "Mumbai to Khandala Taxi Fare",

headingDescription:
  "Omshree Cab provides reliable and comfortable Mumbai to Khandala cab services for travelers looking to enjoy a scenic hill station getaway in the Western Ghats. Whether you are planning a weekend trip, family vacation, romantic outing, or group excursion, our cab service ensures a smooth and safe journey with experienced drivers and well-maintained vehicles. We offer flexible booking options including one-way, round-trip, and multi-day travel plans at transparent per-kilometer pricing. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and tempo travelers suitable for solo travelers, families, and groups. With professional chauffeurs skilled in hill and highway driving, punctual pickups from anywhere in Mumbai, and 24/7 customer support, Omshree Cab is your trusted partner for Mumbai to Khandala cab services.",

topPlaces: [
  {
    title: "Khandala Lake",
    description:
      "Khandala Lake is a serene freshwater lake surrounded by lush hills and greenery. Visitors can enjoy peaceful walks, photography, and a tranquil picnic experience. Traveling by cab ensures a comfortable journey from Mumbai, allowing visitors to spend ample time at the lake without worrying about local transport or parking."
  },
  {
    title: "Rajmachi Fort",
    description:
      "Rajmachi Fort, a historic fort near Khandala, offers panoramic views of the Sahyadri mountains and surrounding valleys. Visitors can explore trekking trails, capture scenic photographs, and enjoy the historic architecture. A cab ride provides convenient access, allowing travelers to plan both fort exploration and hill sightseeing efficiently."
  },
  {
    title: "Tiger’s Leap",
    description:
      "Tiger’s Leap is a popular viewpoint offering stunning cliff-side vistas of the valley below. Visitors can enjoy photography, trekking, and witnessing breathtaking sunsets. Traveling by cab ensures safe and comfortable access, making it easier to explore this iconic Khandala attraction without transport hassles."
  },
  {
    title: "Bhushi Dam",
    description:
      "Bhushi Dam is a famous spot near Khandala where visitors can enjoy water streams, scenic surroundings, and leisurely picnics. It is particularly popular during the monsoon season. Using a cab allows visitors to reach the dam comfortably and plan a relaxing day amidst nature without worrying about local transport."
  },
  {
    title: "Lonavala Market",
    description:
      "Lonavala Market, close to Khandala, is a vibrant area offering local snacks, chikki, handicrafts, and souvenirs. Visitors can explore the local culture, taste regional delicacies, and shop for unique items. A cab service ensures convenient access, enabling travelers to combine shopping with sightseeing efficiently."
  },
  {
    title: "Della Adventure Park",
    description:
      "Della Adventure Park offers thrilling activities such as zip-lining, ATV rides, and rope courses, ideal for adventure enthusiasts and families. Traveling by cab ensures safe and hassle-free transport, allowing visitors to enjoy the full range of activities without worrying about commuting."
  },
  {
    title: "Kune Waterfalls",
    description:
      "Kune Waterfalls are picturesque waterfalls near Khandala, perfect for photography, nature walks, and relaxation. The cascading waters amid lush greenery provide a peaceful retreat. A cab ride allows visitors to explore the waterfalls comfortably and include them in a day’s sightseeing itinerary."
  },
  {
    title: "Amrutanjan Point",
    description:
      "Amrutanjan Point is a scenic viewpoint offering panoramic views of Khandala, Lonavala, and surrounding valleys. Visitors can enjoy photography, trekking, and serene landscapes. Traveling by cab ensures convenient access, giving tourists flexibility to plan multiple viewpoints in one trip."
  },
  {
    title: "Karla Caves",
    description:
      "Karla Caves, located near Khandala, are ancient rock-cut Buddhist caves known for their intricate carvings and historical significance. Visitors can explore the caves, enjoy cultural insights, and capture photography. A cab service provides comfortable travel, allowing sufficient time to visit these heritage sites along with other attractions."
  },
  {
    title: "Pawna Lake",
    description:
      "Pawna Lake is a popular destination for boating, camping, and scenic photography near Khandala. Visitors can enjoy peaceful sunset views and leisure activities by the lake. Traveling by cab ensures hassle-free access, allowing tourists to spend more time enjoying the lake and surrounding natural beauty without worrying about transportation."
  }
],




services: [
{
name: "Mumbai to Khandala Cab",
description: "Mumbai to Khandala cab service offers comfortable travel from Mumbai to the scenic hill station of Khandala. Our fleet includes AC sedans, SUVs, and premium vehicles designed for smooth highway journeys. Professional drivers with experience on ghat roads ensure safe and timely travel throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and Mumbai airport terminals. This service is ideal for weekend trips, family vacations, and romantic hill station getaways. Spacious seating and air-conditioned interiors ensure relaxed travel during the journey. Flexible one-way and round-trip booking options make travel planning convenient. Transparent pricing ensures a reliable and stress-free cab booking experience."
},
{
name: "Mumbai to Khandala Taxi",
description: "Mumbai to Khandala taxi service provides convenient transportation for travelers visiting this beautiful hill destination. Comfortable AC vehicles ensure smooth highway travel along the Mumbai–Pune Expressway route. Experienced drivers ensure safe driving through scenic ghat sections and highway stretches. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for couples, families, and tourists planning short hill station trips. Clean interiors and spacious seating ensure passenger comfort throughout the journey. Flexible departure schedules help passengers plan travel easily. Reliable taxi services guarantee safe and comfortable travel."
},
{
name: "Mumbai to Khandala Cab Service",
description: "Mumbai to Khandala cab service provides dependable road transportation for travelers planning a hill station getaway. Our well-maintained AC vehicles ensure smooth highway travel and comfortable seating for passengers. Professional drivers with route expertise ensure safe travel through mountain roads and expressways. Pickup services are available from residential areas, hotels, offices, and airport terminals across Mumbai. Ideal for sightseeing tours, weekend vacations, and family trips. Spacious vehicles provide relaxed seating during the journey. Flexible booking options allow travelers to schedule trips conveniently. Transparent pricing ensures trustworthy cab service."
},
{
name: "Mumbai to Khandala Taxi Service",
description: "Mumbai to Khandala taxi service offers efficient and comfortable road travel for passengers planning hill station visits. Our fleet includes AC vehicles that ensure relaxed highway journeys. Skilled drivers ensure safe driving through the scenic Western Ghats route. Pickup services are available from homes, offices, hotels, and airport terminals across Mumbai. Ideal for couples, families, and tourists seeking a quick getaway. Spacious seating ensures comfortable travel throughout the journey. Flexible booking options allow convenient trip planning. Affordable fares ensure a pleasant and smooth taxi travel experience."
},
{
name: "Cab from Mumbai to Khandala",
description: "Cab from Mumbai to Khandala offers private and comfortable transportation for travelers visiting this popular hill destination. Our AC vehicles ensure smooth highway journeys and pleasant travel conditions. Professional drivers ensure safe driving along ghat roads and highways. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for couples, families, and small groups planning sightseeing trips. Spacious interiors ensure relaxed seating throughout the journey. Flexible travel timing allows convenient departure planning. Reliable cab services ensure safe and stress-free travel."
},
{
name: "Taxi from Mumbai to Khandala",
description: "Taxi from Mumbai to Khandala provides dependable transportation for travelers seeking comfortable road travel. Our AC vehicles ensure pleasant journeys along highways and scenic hill routes. Experienced drivers ensure safe driving and punctual arrival at the destination. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists, families, and corporate travelers planning leisure trips. Clean interiors and spacious seating ensure passenger comfort. Flexible booking options allow convenient travel scheduling. Professional taxi services ensure reliable intercity travel."
},
{
name: "Mumbai to Khandala Cab Booking",
description: "Mumbai to Khandala cab booking allows travelers to reserve vehicles easily for hill station journeys. Online and phone booking options provide instant confirmation and convenient scheduling. Comfortable AC sedans and SUVs ensure smooth highway travel. Professional drivers ensure safe driving and punctual pickup services. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists visiting Khandala for sightseeing and relaxation. Flexible one-way and round-trip booking options are available. Reliable booking service ensures hassle-free travel planning."
},
{
name: "Mumbai to Khandala Taxi Booking Online",
description: "Mumbai to Khandala taxi booking online provides a quick and easy reservation system for passengers planning travel. Instant confirmation allows travelers to schedule their trips without delays. Comfortable AC vehicles ensure relaxed highway journeys. Experienced drivers provide safe and professional driving services. Pickup is available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for families, couples, and tourists planning hill station visits. Flexible travel timing allows convenient trip scheduling. Reliable booking systems ensure smooth taxi reservations."
},
{
name: "Mumbai to Khandala Cab Price",
description: "Mumbai to Khandala cab price offers affordable and transparent travel options for passengers visiting the hill station. Clear pricing details allow travelers to understand the total trip cost before booking. Our fleet includes sedans, SUVs, and premium vehicles suited for various travel needs. Comfortable seating and AC interiors ensure relaxed travel conditions throughout the journey. Professional drivers ensure safe highway travel and punctual arrival. Pickup services are available across Mumbai including airport terminals. Flexible travel options allow passengers to choose one-way or round-trip journeys. Budget-friendly fares ensure convenient cab travel."
},
{
name: "Mumbai to Khandala Taxi Fare",
description: "Mumbai to Khandala taxi fare is calculated with transparent per-kilometer pricing to ensure clear travel costs. Passengers can choose vehicles based on comfort and budget preferences. Our AC vehicles ensure smooth highway travel and relaxed journeys. Experienced drivers ensure safe driving and timely arrival at the destination. Pickup services are available from homes, hotels, offices, and airports across Mumbai. Ideal for family travel and tourist trips. Flexible booking options allow easy travel planning. Reliable fare structure ensures stress-free taxi booking."
},
{
name: "Mumbai to Khandala One Way Cab",
description: "Mumbai to Khandala one way cab service is perfect for travelers who require a drop service without paying return charges. This option helps reduce travel expenses while ensuring comfortable transportation. AC sedans and SUVs provide relaxed seating for highway travel. Professional drivers ensure safe driving through scenic ghat sections. Pickup services are available from homes, hotels, offices, and airport terminals across Mumbai. Ideal for tourists visiting Khandala for short trips. Flexible departure timing ensures convenient scheduling. Reliable one-way cab service ensures affordable travel."
},
{
name: "Mumbai to Khandala Round Trip Taxi",
description: "Mumbai to Khandala round trip taxi service offers complete travel convenience for passengers planning return journeys. Flexible return timing allows travelers to explore the hill station comfortably. Comfortable AC vehicles ensure relaxed travel during the entire trip. Professional drivers remain available for return travel according to passenger schedules. Pickup services are available across Mumbai including homes, hotels, and airport terminals. Ideal for weekend vacations and sightseeing tours. Spacious vehicles ensure comfortable travel for families and groups. Reliable round-trip taxi service ensures smooth travel planning."
}
],

tableData: [
["Mumbai to Khandala Cab","Mumbai to Khandala Taxi"],
["Mumbai to Khandala Cab Service","Mumbai to Khandala Taxi Service"],
["Cab from Mumbai to Khandala","Taxi from Mumbai to Khandala"],
["Mumbai to Khandala Cab Booking","Mumbai to Khandala Taxi Booking Online"],
["Mumbai to Khandala Cab Price","Mumbai to Khandala Taxi Fare"],
["Mumbai to Khandala One Way Cab","Mumbai to Khandala Round Trip Taxi"]
],




whychoose: [
  {
    WhyChooseheading: "Experienced Expressway Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in driving on the Mumbai–Pune Expressway and the scenic hill roads leading to Khandala. Their knowledge of highway traffic patterns and ghat sections ensures a safe and smooth journey for passengers."
  },
  {
    WhyChooseheading: "Transparent Taxi Fare",
    WhyChoosedescription: "Omshree Cabs provides clear and transparent Mumbai to Khandala taxi fare details before booking. We explain per-kilometer pricing, toll charges, and travel packages in advance so customers never face hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Availability",
    WhyChoosedescription: "Whether you are planning a quick weekend getaway or a same-day hill station trip, Omshree Cabs offers 24/7 cab booking for Mumbai to Khandala travel."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "Our fleet includes well-maintained and fully air-conditioned vehicles that are regularly cleaned and sanitized. This ensures a comfortable and refreshing ride during your Khandala trip."
  },
  {
    WhyChooseheading: "Flexible Travel Options",
    WhyChoosedescription: "We offer flexible travel options including one-way cabs, round trips, and same-day return packages from Mumbai to Khandala so travelers can plan their journey easily."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Omshree Cabs offers a variety of vehicles including sedan cars, SUVs like Ertiga and Innova, and premium vehicles suitable for couples, families, and group travelers."
  },
  {
    WhyChooseheading: "Doorstep Pickup from Mumbai",
    WhyChoosedescription: "We provide convenient pickup from homes, hotels, offices, and airports anywhere in Mumbai. Our drivers arrive on time so your journey to Khandala begins smoothly."
  },
  {
    WhyChooseheading: "Reliable Hill Station Travel Service",
    WhyChoosedescription: "Omshree Cabs is trusted by many travelers for Mumbai to Khandala trips. Our punctual service, professional drivers, and comfortable vehicles ensure a relaxing hill station journey."
  }
]
};

const faqData = [
  { question: "What is the distance from Mumbai to Khandala by cab?", answer: "The distance from Mumbai to Khandala is approximately 80 km and the journey usually takes around 1.5–2 hours depending on traffic and road conditions." },
  { question: "Do you provide one-way Mumbai to Khandala cab services?", answer: "Yes, Omshree Cabs provides both one-way and round-trip cab services between Mumbai and Khandala." },
  { question: "Which vehicles are available for Mumbai to Khandala travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, and premium vehicles depending on your group size and comfort preference." },
  { question: "Is pickup available from Mumbai Airport?", answer: "Yes, we provide direct pickup from Mumbai Airport for Khandala cab bookings." },
  { question: "Can we visit Lonavala during the Khandala trip?", answer: "Yes, many travelers combine Khandala travel with Lonavala sightseeing as both hill stations are located very close to each other." },
  { question: "Are all vehicles air-conditioned?", answer: "Yes, all vehicles provided by Omshree Cabs are fully air-conditioned for comfortable travel." },
  { question: "Do you offer same-day return packages?", answer: "Yes, same-day return cab packages from Mumbai to Khandala are available." },
  { question: "Can we stop during the journey for food or sightseeing?", answer: "Yes, passengers can request stops during the journey for meals, refreshments, or scenic viewpoints." },
  { question: "Is advance booking recommended?", answer: "Yes, advance booking is recommended especially during weekends and holiday seasons when Khandala receives many tourists." },
  { question: "Are vehicles sanitized before travel?", answer: "Yes, all vehicles are cleaned and sanitized regularly to ensure passenger safety and hygiene." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohit Shah",
    feedback:
      "We booked Omshree Cabs for our Mumbai to Khandala trip. The driver was punctual and handled the expressway and hill roads very well. The car was clean and comfortable.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Neha Kulkarni",
    feedback:
      "Our family trip to Khandala with Omshree Cabs was fantastic. On-time pickup, smooth driving, and transparent pricing made the journey very enjoyable.",
    rating: 5
  }
];






















































const Images = [
  { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cab" },
{ place: "/images/keyword/2.jpeg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
{ place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
{ place: "/images/keyword/5.jpeg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
{ place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
{ place: "/images/keyword/7.jpeg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
{ place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
{ place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
{ place: "/images/keyword/11.jpeg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
{ place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
{ place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
{ place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
{ place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
{ place: "/images/keyword/16.jpeg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
{ place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
{ place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
{ place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
{ place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
{ place: "/images/keyword/21.jpeg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
{ place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Khandala Taxi Fare",
  "description": "Book Mumbai to Khandala Cab with Omshree Cab for comfortable hill station travel. Reliable taxi service from Mumbai to Khandala with options for one-way or round trips. Check cab fares, easy online booking, and safe travel for your Khandala trip.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "1850"
  }
};









  return (
    <div>
      <Helmet>
  <title>Mumbai to Khandala Taxi Fare | Contact: +91 9892544084 | Omshree Cab</title>
  <meta 
    name="description" 
    content="Book Mumbai to Khandala Cab with Omshree Cab for comfortable travel. Taxi service from Mumbai to Khandala with one-way and round trip options. Check cab fares, easy online booking, and safe travel." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/19.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Omshree Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚙
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Omshree Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Omshree Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
       <div className="pc-contact">
      <h4 className="pc-title">Contact Information</h4>

      <div className="pc-grid">
        {/* Phones */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsTelephoneFill className="pc-icon" />
            <span>Phone Numbers</span>
          </header>

          <div className="pc-list">
            <a href="tel:+919892544084" className="pc-call">
              +91 9892544084
            </a>
          </div>

          <div className="pc-cta">
            <a
              href="https://wa.me/919892544084"
              target="_blank"
              rel="noopener noreferrer"
              className="pc-whats"
            >
              <BsWhatsapp /> WhatsApp
            </a>

            <a href="tel:+919892544084" className="pc-primary">
              Call Now
            </a>
          </div>
        </section>

        {/* Email */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsEnvelopeFill className="pc-icon" />
            <span>Email</span>
          </header>

          <a href="mailto:booking@omshreecabs.com" className="pc-email">
            booking@omshreecabs.com
          </a>
        </section>

        {/* Address */}
        <section className="pc-tile">
          <header className="pc-tile-head">
            <BsGeoAltFill className="pc-icon" />
            <span>Address</span>
          </header>

          <address className="pc-address">
            <strong>Omshree Cab</strong>
            <br />
           Shri Omkar Co-op Housing Society,
            <br />
            E-11/101, Sector 9,
Ghansoli (Gharonda),
            <br />
            Navi Mumbai, Maharashtra, India - 400701
          </address>
        </section>
      </div>
    </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokhandalataxifare;